<template>
  <SettingForm />
</template>

<script>
import SettingForm from '@/layouts/components/form/SettingForm.vue'

export default {
  components: { SettingForm },
}
</script>
